import { BoardLayout } from "~/config/andonBoardLayouts/andonLayout.types";

const layouts: BoardLayout[] = [
  {
    name: "Site 1",
    dimensions: {
      rows: 5,
      columns: 9
    },
    layout: [
      {
        w: 1,
        h: 1,
        x: 0,
        y: 4,
        i: "7c4a22f3-19cb-42af-944e-6c23cbac1e44",
        maxH: 2,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 1,
        y: 4,
        i: "4d629497-80ee-41c3-b9c6-d0d8ac8dcdcb",
        maxH: 2,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 2,
        i: "45c6d659-372b-4830-a729-ea07914e2181",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 3,
        y: 2,
        i: "43faa114-0105-4194-b3ef-8cbd61a8c5b8",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 2,
        i: "7e440f40-dd72-4897-a0fe-ba1abf8c4618",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 5,
        y: 2,
        i: "3ad858c3-e699-4bcc-a41f-3058158db4d5",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 6,
        y: 2,
        i: "24448279-8a25-4daa-8796-290f83323012",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 7,
        y: 2,
        i: "4ce518b5-f7b0-4989-a3ff-1b305838d480",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 8,
        y: 2,
        i: "92dd4aae-4263-4253-8364-8d2144c4529b",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 0,
        i: "e04d0f04-bde7-4742-9cac-89a34c3d9e47",
        maxH: 6,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 1,
        y: 0,
        i: "07f08ba8-f5d3-4f3c-8f87-34a8f4e8d3db",
        maxH: 6,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 0,
        i: "cadc94fa-b834-4fb2-8621-a1bcbc80714a",
        maxH: 6,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 3,
        y: 0,
        i: "b0347821-f6bf-402d-bc5f-39ad2e04e13b",
        maxH: 6,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 0,
        i: "cbfb147f-cebe-45cf-834d-36500fa875b8",
        maxH: 6,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 5,
        y: 0,
        i: "7da06320-b73a-4cfa-8b73-8e6afa3e251f",
        maxH: 6,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 6,
        y: 0,
        i: "26ed3769-6e4e-4b0a-b774-9423f1804b70",
        maxH: 6,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 7,
        y: 0,
        i: "8a415734-c742-4a30-89e5-2552e8366609",
        maxH: 6,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 8,
        y: 0,
        i: "3f08b481-e24b-425c-9e5d-a87457a2285d",
        maxH: 6,
        moved: false,
        static: false
      }
    ]
  }
];

export default layouts;
